import React from "react";
import { ProgressBar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import ScorePercentDisplayBG from "./ScorePercentDisplayBG";
function ScoreBox(props) {
  function ScorePercChooser() {
    switch (props.type) {
      case "Defense":
      case "Offense":
        return (
          <ScorePercentDisplayBG
            curValue={props.Scores[props.type].TotalScore}
            maxValue={props.Scores[props.type].Max.Total}
            stars={props.Scores.Stars[props.type]}
            chartType={props.type}
          />
        );
      case "Efficiency":
        return (
          <ScorePercentDisplayBG
            curValue={props.Scores.Efficiency}
            maxValue={props.Scores.EfficiencyMax}
            stars={props.Scores.Stars[props.type]}
            chartType={"Efficiency"}
          />
        );

      default:
        return (
          <ScorePercentDisplayBG
            curValue={props.Scores.Total}
            maxValue={props.Scores.MaxTotal}
            stars={props.Scores.Stars[props.type]}
            chartType={"Total"}
          />
        );
    }
  }

  function BarChooser() {
    let displayData = [];
    switch (props.type) {
      case "Defense":
        let scoreArr = props.Scores[props.type];
        let OffObj = {
          Estate: {
            Current: scoreArr.EstateScore,
            Max: scoreArr.Max.EstateScore,
            Label: "ESTATE",
          },
          Flex: {
            Current: scoreArr.BRScore,
            Max: scoreArr.Max.BRScore,
            Label: "FLEX",
          },

          Risk: {
            Current:
              scoreArr.LOLScore +
              scoreArr.LOIScore +
              scoreArr.LOHScore +
              scoreArr.LOPScore,
            Max:
              scoreArr.Max.LOLScore +
              scoreArr.Max.LOIScore +
              scoreArr.Max.LOHScore +
              scoreArr.Max.LOPScore,
            Label: "RISK TOLERANCE",
          },
          Debt: {
            Current: scoreArr.DPScore,
            Max: scoreArr.Max.DPScore,
            Label: "Debt",
          },
        };

        for (const key in OffObj) {
          if (props.Scores[props.type].Max[key] !== 0) {
            displayData.push({
              key: key,
              cur: OffObj[key].Current,
              max: OffObj[key].Max,
              label: OffObj[key].Label,
            });
          }
        }

        break;
      case "Offense":
        for (const key in props.Scores[props.type].Labels) {
          if (props.Scores[props.type].Max[key] !== 0) {
            displayData.push({
              key: key,
              cur: props.Scores[props.type][key],
              max: props.Scores[props.type].Max[key],
              label: props.Scores[props.type].Labels[key],
            });
          }
        }
        break;
      case "Total":
        displayData = [
          {
            key: "Offense",
            cur: props.Scores.Offense.TotalScore,
            max: props.Scores.Total, //props.Scores.Offense.Max.Total,
            label: "Offense",
          },
          {
            key: "Defense",
            cur: props.Scores.Defense.TotalScore,
            max: props.Scores.Total, //props.Scores.Defense.Max.Total,
            label: "Defense",
          } /*,
          {
            key: "Efficiency",
            cur: props.Scores.EfficiencyMax - props.Scores.Efficiency,
            max: props.Scores.EfficiencyMax,
            label: "Efficiency",
          },*/,
        ];
        break;

      case "Efficiency":
        break;
      default:
        break;
    }
    displayData.sort(
      (a, b) => b.cur / parseFloat(b.max) - a.cur / parseFloat(a.max)
    );
    return (
      <>
        {displayData.map((item) => {
          return (
            <div className="barTitle" key={item.key}>
              <span>{item.label.toUpperCase().replaceAll(" SCORE", "")}</span>
              {props.Dev === undefined || props.Dev === true ? (
                <>
                  {/* {`(${item.cur} out of ${item.max})`} */}
                  <ProgressBar
                    now={item.cur}
                    max={item.max}
                    label={`${item.cur} / ${item.max}`}
                  />
                </>
              ) : (
                <ProgressBar now={item.cur} max={item.max} />
              )}
            </div>
          );
        })}
      </>
    );
  }
  return (
    <div className="scoreBox">
      <div className="half" id={`${props.type}_Bars`}>
        <span className="ScoreHeader">{props.header}</span>

        <span className="ScoreDesc">{props.desc}</span>

        {BarChooser()}
      </div>

      <div className="half" id={`${props.type}_Image`}>
        {ScorePercChooser()}
      </div>
    </div>
  );
}

export default ScoreBox;
